import React from 'react';
import { Box, MenuItem, Pagination, TextField, Typography } from '@mui/material';

/**
 * Le pied d'un tableau — nombre de résultats, lignes par page, pagination.
 *
 * 🔴 CE COMPOSANT EXISTE PARCE QUE DEUX ÉCRANS N'AVAIENT AUCUNE PAGINATION.
 * Mesuré avant écriture : Produits, Commandes et Fournisseurs en avaient une ;
 * **Réception et Comptabilité n'en avaient pas du tout**. Sur ces deux-là, une
 * liste longue s'affichait entière ou se coupait sans le dire — le défaut
 * n'était pas cosmétique.
 *
 * ⚠️ ET C'EST TOUT CE QUI EST PARTAGÉ DU TABLEAU. Un `<TableauCommun
 * colonnes={[…]}>` piloté par une description de colonnes est exactement le
 * composant à douze props qu'on refuse : les cinq tables ont des cellules trop
 * différentes — une image de produit ici, une pastille de statut là, cinq
 * icônes d'action ailleurs. **Les cellules restent écrites à la main dans
 * chaque écran** ; seul le pied est commun, parce que lui est identique.
 *
 * ⚠️ `total` est le nombre de RÉSULTATS, pas le nombre de pages : c'est ce que
 * le client veut savoir (« 47 produits »), et c'est aussi ce qui permet de
 * dire « aucun résultat » sans le confondre avec « une page vide ».
 */
const PiedTableau = ({
  total,
  page,
  pages,
  parPage,
  onPage,
  onParPage,
  libelleTotal,
  libelleParPage,
  optionsParPage = [10, 20, 50, 100],
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      flexWrap: 'wrap',
      mt: 2,
    }}
  >
    <Typography variant="body2" color="text.secondary">
      {libelleTotal}
    </Typography>

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      {onParPage ? (
        <TextField
          select
          size="small"
          label={libelleParPage}
          value={parPage}
          onChange={(e) => onParPage(Number(e.target.value))}
          sx={{ minWidth: 110 }}
        >
          {optionsParPage.map((n) => (
            <MenuItem key={n} value={n}>{n}</MenuItem>
          ))}
        </TextField>
      ) : null}

      {/* ⚠️ La pagination disparaît quand il n'y a qu'une page : afficher une
          pagination à un seul bouton donne l'impression qu'il y a une suite. */}
      {pages > 1 ? (
        <Pagination
          count={pages}
          page={page}
          onChange={(_, valeur) => onPage(valeur)}
          color="primary"
          size="small"
        />
      ) : null}
    </Box>
  </Box>
);

export default PiedTableau;
